const TrackedIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="54" height="54" rx="27" stroke="#171717" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2423 19.2724C37.0456 19.2724 37.6968 19.9236 37.6968 20.7269C37.6968 21.5303 37.0456 22.1815 36.2423 22.1815C35.439 22.1815 34.7877 21.5303 34.7877 20.7269C34.7877 19.9236 35.439 19.2724 36.2423 19.2724ZM39.6362 20.7269C39.6362 18.8525 38.1167 17.333 36.2423 17.333C34.3679 17.333 32.8484 18.8525 32.8484 20.7269C32.8484 22.6014 34.3679 24.1209 36.2423 24.1209C38.1167 24.1209 39.6362 22.6014 39.6362 20.7269Z"
        fill="#171717"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7579 33.8183C20.5612 33.8183 21.2125 34.4695 21.2125 35.2728C21.2125 36.0762 20.5612 36.7274 19.7579 36.7274C18.9546 36.7274 18.3034 36.0762 18.3034 35.2728C18.3034 34.4695 18.9546 33.8183 19.7579 33.8183ZM23.1519 35.2728C23.1519 33.3984 21.6323 31.8789 19.7579 31.8789C17.8835 31.8789 16.364 33.3984 16.364 35.2728C16.364 37.1473 17.8835 38.6668 19.7579 38.6668C21.6323 38.6668 23.1519 37.1473 23.1519 35.2728Z"
        fill="#171717"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2422 24.3639C20.2422 21.82 22.3044 19.7578 24.8482 19.7578H34.3028V21.6972H24.8482C23.3755 21.6972 22.1816 22.8911 22.1816 24.3639C22.1816 25.8366 23.3755 27.0305 24.8482 27.0305H33.5755C36.1194 27.0305 38.1816 29.0927 38.1816 31.6366C38.1816 34.1805 36.1194 36.2427 33.5755 36.2427H22.1816V34.3033H33.5755C35.0483 34.3033 36.2422 33.1094 36.2422 31.6366C36.2422 30.1638 35.0483 28.9699 33.5755 28.9699H24.8482C22.3044 28.9699 20.2422 26.9077 20.2422 24.3639Z"
        fill="#171717"
      />
    </svg>
  );
};

export default TrackedIcon;
